'use client';

import { ResponsiveStyleValue } from '@coolblue-development/freddy';
import goToShoppingCartTrigger from '@coolblue-development/ga4-events/triggers/AddToCartPage/goToShoppingCartTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { AddToCartPageType } from '@features/add-to-cart-page/typings/AddToCartPageSection';
import { useTranslation } from '@i18n/useTranslation';

import StyledButton from '../ShoppingCartButton.styled';

type Props = {
  productId: number;
  href: string;
  pageType: AddToCartPageType;
  flex?: ResponsiveStyleValue<'flex'>;
};

export default function ShoppingCartButton({ productId, href, pageType, flex }: Props) {
  const { t } = useTranslation('webshop');
  const { trackEvent } = useAnalytics();

  function onClick() {
    trackEvent(
      goToShoppingCartTrigger({
        sub_feature: pageType,
        primary_item_id: productId
      })
    );
  }

  return (
    <StyledButton
      flex={flex}
      variant='action'
      onClick={onClick}
      component='a'
      href={href}
      fullWidth
    >
      {t('addToCart.viewShoppingCart')}
    </StyledButton>
  );
}
